import styled from 'styled-components';
import { Building } from '@styled-icons/fa-regular/Building';
import { Card, Modal, Button } from 'antd';

export const ContainerProjects = styled.div`
  position: relative;
  flex-wrap: wrap;
  padding: 0.5rem;
  text-align: start;
`;

export const CardEmptyMockup = styled(Card)`
  width: 20rem;
  margin-right: 1rem;
`;

export const BuildingIcon = styled(Building)`
  color: ${({ theme }) => theme.colors.grayDark2};
  width: 2.5rem;
  margin-right: 0.5rem;
  margin-left: 0.5rem;
`;

export const CheckNewContractModal = styled(Modal)`
  & .ant-modal-body {
    padding: 1rem;
    color: ${({ theme }) => theme.colors.grayDark2};

    & > h3 {
      font-size: 1rem;
      font-weight: 600;
      margin-bottom: 0.5rem;
    }

    & > span {
      font-size: 0.875rem;
    }
  }
`;

export const AntdButton = styled(Button)``;

export const ProjectsMockupHeader = styled.header`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.5rem;
  & > .subtitle {
    font-size: 1rem;
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.grayDark2};
  }
  margin-bottom: 0.5rem;
`;

export const ProjectsMockupFilterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  column-gap: 1rem;
  max-width: 41.375rem;
  margin-top: 1.5rem;

  & > div {
    width: 100%;
  }

  & > button {
    width: 100%;
    max-width: 11rem;
  }
`;

export const EmptyContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white4};
  height: calc(100vh - 24.5rem);
  padding-top: 2.5rem;
  text-align: center;

  & > h4 {
    color: ${({ theme }) => theme.colors.grayDark4};
  }
`;
